import React from "react";
import Table from "../base-table";
import type { TableRef } from "../base-table";
import { getCoreRowModel } from "@tanstack/react-table";
import { ProductComponent } from "../../graphql/graphql";
import { getClassificationDetailsTableColumns } from "./ClassificationDetailsTableColumns";

interface ClassificationDetailsTableProps {
  data: ProductComponent[];
  tableRef: React.Ref<TableRef>;
}

export const ClassificationDetailsTable: React.FC<ClassificationDetailsTableProps> = ({ data, tableRef }) => {
  const columns = React.useMemo(() => getClassificationDetailsTableColumns(), []);
  const rowModel = getCoreRowModel();

  return (
    <Table
      ref={tableRef}
      data={data}
      columns={columns}
      getCoreRowModel={rowModel}
      className="classification-details-table"
    />
  );
};


